import { Card, CardBody, CardHeader, Col } from "reactstrap";
import { H5, P, SVG } from "../../../../AbstractElements";
import ReactApexChart from "react-apexcharts";
import { totalEarningData } from "../../../../Data/Dashboard/CryptoDashboard/CryptoDashboard";

const TotalEarning = () => {
  return (
    <>
      {totalEarningData.map((data, i) => (
        <Col lg="4" md={i !== 2 ? "6" : ""} className={`proorder-xl-${i+1} proorder-lg-${i+1}`} key={i}>
          <Card className="total-earning">
            <CardHeader className="card-no-border pb-0">
              <div className="d-flex">
                <div className="badge badge-rounded animation">
                  <SVG className={data.class} iconId={data.icon} />
                </div>
                <div className="flex-grow-1">
                  <H5>{data.amount}</H5>
                  <P className="d-flex">
                    <span className={`bg-light-${data.color} me-2`}>
                      <SVG iconId={data.arrowIcon} />
                    </span>
                    <span className={`font-${data.color} me-2`}>
                      {data.percentage}
                    </span>
                    <span>Since last month</span>
                  </P>
                </div>
              </div>
            </CardHeader>
            <CardBody className="p-0">
              <div>
                <ReactApexChart options={data.chart} series={data.chart.series} type={data.chart.chart?.type} height={95} />
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </>
  );
};

export default TotalEarning;
